export enum ReviewStatus {
  notSubmitted = 'not-submitted',
  inReview = 'in-review',
  approved = 'approved',
  rejected = 'rejected',
  pushedBack = 'pushed-back',
}
